module.exports = __webpack_public_path__ + "img/5.95ca7981.png";